module.exports = __webpack_public_path__ + "static/media/stepFinish.946059b1.png";